<button tabindex="100" (click)="onClick.emit()" [attr.aria-label]="'Retour arrière'" id="sub-navbar-previous"
        class="border-black border-3 bg-white border-black border rounded-full inline-flex items-center justify-center py-3 px-6 my-1 cursor-pointer w-full
  text-center text-2xl font-medium text-theme-black font-theme-source
  over:brightness-75 disabled:opacity-75" [disabled]="disabled">
  <i class="fa-solid fa-arrow-left"></i> {{text}}
</button>
